interface Props {
	title: string;
	width?: string;
	value: string;
	setState: (value: string) => void;
	fontColor?: string;
	fontSize?: string;
	fontWeight?: string;
	titleClassName?: string;
	inputClassName?: string;
	required?: boolean;
}

const SimpleTextField = ({
	title,
	value,
	setState,
	fontColor,
	fontSize,
	fontWeight,
	width,
	titleClassName,
	inputClassName,
	required = false,
}: Props) => {
	const defaultTitleClassName = `${fontSize || 'text-sm'} ${fontColor || ''} ${fontWeight || ''}`;
	const defaultInputClassName = `${width || 'w-full'} h-8 rounded-[4px] border-[1px] border-gray-400 pl-2 text-xs text-gray-800`;

	return (
		<div className={`${width || 'w-full'}`}>
			<div className={titleClassName || defaultTitleClassName}>
				{title}
				{required && <span className="text-red">*</span>}
			</div>
			<input
				type="text"
				value={value}
				onInput={(e) => setState(e.currentTarget.value as string)}
				className={inputClassName || defaultInputClassName}
			/>
		</div>
	);
};

export default SimpleTextField;
